import React from 'react'
import styled from 'styled-components'
import { SCHOOL } from '@laputan/core'
import { Dropdown } from '../../components/Dropdown'

const StyledStateDropdown = styled(Dropdown)``

interface IStateDropdownProps {
  className?: string
  value?: string
  onChange: (s: string | Array<string>) => void
  isMenuLeft?: boolean
  isShowBorder?: boolean
  isInline?: boolean
  labelText?: string
  required?: boolean
  validationMessage?: string
  isDisabled?: boolean
  isMenuPositionDown?: boolean
}

const StateDropdown: React.FC<IStateDropdownProps> = ({
  className,
  value,
  onChange,
  isMenuLeft = true,
  labelText,
  isShowBorder = false,
  validationMessage,
  isInline = true,
  isDisabled,
  required,
  isMenuPositionDown,
}) => (
  <StyledStateDropdown
    labelText={labelText}
    className={className}
    isInline={isInline}
    isDisabled={isDisabled}
    isShowDefault
    isMenuLeft={isMenuLeft}
    isShowBorder={isShowBorder}
    required={required}
    validationMessage={validationMessage}
    isMenuPositionDown={isMenuPositionDown}
    onChange={(s) => {
      if (s === value) {
        return
      }
      onChange(s)
    }}
    items={[{ text: '--Select--', value: null }].concat(SCHOOL.STATES_SEQUENCE)}
    value={value}
  />
)

export { StateDropdown }
